import { omit } from 'lodash/fp';
import type * as React from 'react';
import type { CurrentUserDto } from '../../../../types/UserDtos';
import { getCurrentUser } from '../../services/CurrentUser';

export type AppContext = {
    user: CurrentUserDto;
};

const appContext: AppContext = {
    user: getCurrentUser(),
};

type Props = { appContext: AppContext };

export function withAppContext<InnerProps extends Props>(
    Component: React.ComponentType<InnerProps>
): React.ComponentType<Omit<InnerProps, 'appContext'>> {
    const newComponent: React.FC<Omit<InnerProps, 'appContext'>> = function (props: Omit<InnerProps, 'appContext'>) {
        return <Component {...(props as any)} appContext={appContext} />;
    };
    newComponent.propTypes = omit('appContext', Component.propTypes);

    return newComponent;
}
